import { render } from "./Invoices.vue?vue&type=template&id=2f076dce"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"

import "./Invoices.vue?vue&type=style&index=0&id=2f076dce&lang=css"
script.render = render

export default script